import { AclAction, CompanyRoleEnum } from 'shared/domains/apollo/generated/types';
import useAccount from 'shared/domains/users/hooks/useAccount';
export function useACLCan(params) {
    const { userAcls = [], teamAcls = [] } = params;
    const account = useAccount();
    const can = (action) => (userId = account.data.userId) => {
        if (userId === account.data.userId && account.data.role === 'owner') {
            if (action === AclAction.Traverse) {
                return false;
            }
            return true;
        }
        const hasUserAccess = userAcls.some((access) => access.userId === userId && access.actions.includes(action));
        const hasTeamAccess = teamAcls.some((access) => {
            const userIsTeamMember = Boolean(access.team.members.some((member) => member.userId === userId));
            return userIsTeamMember && access.actions.includes(action);
        });
        // Because of legacy reasons, lets assume all data can be undefined.
        const hasAccessTroughProject = teamAcls.some((access) => {
            const { isProjectTeam, members } = access.team;
            const hasAction = access.actions.includes(action);
            const userIsTeamMember = Boolean(members.some((member) => member.userId === userId));
            return isProjectTeam && hasAction && userIsTeamMember;
        });
        return Boolean(hasUserAccess || hasTeamAccess || hasAccessTroughProject);
    };
    const getAccessLevel = (userId, role) => {
        if (role === 'owner') {
            return 'full';
        }
        if (can(AclAction.Write)(userId)) {
            return 'full';
        }
        if (can(AclAction.Read)(userId)) {
            return 'read';
        }
        if (can(AclAction.Traverse)(userId)) {
            return 'traverse';
        }
        return 'none';
    };
    return {
        canTraverse: can(AclAction.Traverse),
        canRead: can(AclAction.Read),
        canWrite: can(AclAction.Write),
        canDelete: can(AclAction.Delete),
        accessLevel: getAccessLevel(account.data.userId || '', account.data.role || CompanyRoleEnum.Member),
        getAccessLevel,
    };
}
